(function () {
  'use strict';

  var ovaleSizeChartModalState = null;
  var ovaleVisitorCountryRequest = null;

  function getOvaleSizeChartConfig() {
    var configNode;

    if (window.amourSizeChartConfig) return window.amourSizeChartConfig;

    configNode = document.querySelector('[data-amour-size-chart-config]');
    if (!configNode) return null;

    try {
      window.amourSizeChartConfig = JSON.parse(configNode.textContent || '');
      return window.amourSizeChartConfig;
    } catch (error) {
      return null;
    }
  }

  function escapeSizeChartHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function getSizeChartCountry(config) {
    var country = window.Shopify && window.Shopify.country;
    var supported = (config.countries || []).some(function (option) {
      return option.value === country;
    });

    if (country === 'GB') country = 'UK';
    if (country === 'CA') country = 'US';

    supported = (config.countries || []).some(function (option) {
      return option.value === country;
    });

    return supported ? country : (config.defaultCountry || 'UK');
  }

  function getSizeChartCountryOption(config, country) {
    return (config.countries || []).find(function (option) {
      return option.value === country;
    }) || {};
  }

  function buildSizeChartRows(config, country) {
    return (config.rows || []).map(function (row) {
      var localSize = row.sizes[country] || row.sizes[row.defaultCountry] || '';
      return '<tr><th scope="row">' + escapeSizeChartHtml(row.eu) + '</th><td>' + escapeSizeChartHtml(localSize) + '</td><td>' + escapeSizeChartHtml(row.diameter) + '</td></tr>';
    }).join('');
  }

  function buildOvaleSizeChart(config, country) {
    var countryOption = getSizeChartCountryOption(config, country);
    var options = (config.countries || []).map(function (option) {
      return '<option value="' + escapeSizeChartHtml(option.value) + '"' + (option.value === country ? ' selected' : '') + '>' + escapeSizeChartHtml(option.label) + '</option>';
    }).join('');
    var icon = config.titleIcon ? '<span class="amour-size-chart-modal__title-icon" aria-hidden="true"><img src="' + escapeSizeChartHtml(config.titleIcon) + '" alt="" loading="lazy"></span>' : '';
    var note = config.customOrderNote ? '<div class="amour-size-chart-modal__note">' + escapeSizeChartHtml(config.customOrderNote) + '</div>' : '';

    return '' +
      '<div class="amour-size-chart-modal__inner' + (config.localizedLabels ? ' notranslate' : '') + '"' + (config.localizedLabels ? ' translate="no"' : '') + '>' +
        '<div class="amour-size-chart-modal__header">' +
          '<div class="amour-size-chart-modal__heading">' +
            '<div class="amour-size-chart-modal__title-row">' + icon + '<h3 class="amour-size-chart-modal__title">' + escapeSizeChartHtml(config.title) + '</h3></div>' +
            '<p class="amour-size-chart-modal__subtitle">' + escapeSizeChartHtml(config.subtitle) + '</p>' +
          '</div>' +
        '</div>' +
        '<div class="amour-size-chart-modal__section">' +
          '<div class="amour-size-chart-modal__section-bar">' +
            '<div class="amour-size-chart-modal__section-title">' + escapeSizeChartHtml(config.tableHeader) + '</div>' +
            '<label class="amour-size-chart-modal__country"><span>' + escapeSizeChartHtml(config.countryLabel || 'Country') + '</span><select translate="no" class="notranslate" data-size-chart-country>' + options + '</select></label>' +
          '</div>' +
          '<div class="amour-size-chart-modal__selected-country">' + escapeSizeChartHtml(config.showingLabel || 'Showing sizes for') + ' <strong translate="no" class="notranslate" data-size-chart-country-label>' + escapeSizeChartHtml(countryOption.label || country) + '</strong></div>' +
          '<div class="amour-size-chart-modal__table-wrap" data-size-chart-scroll-wrap>' +
            '<table class="amour-size-chart-modal__table"><thead><tr><th scope="col">' + escapeSizeChartHtml(config.euLabel || 'EU SIZE') + '</th><th scope="col" translate="no" class="notranslate" data-size-chart-country-heading>' + escapeSizeChartHtml(countryOption.shortLabel || country) + '</th><th scope="col">' + escapeSizeChartHtml(config.diameterLabel || 'DIAMETER') + '</th></tr></thead><tbody data-size-chart-rows>' + buildSizeChartRows(config, country) + '</tbody></table>' +
          '</div>' + note +
        '</div>' +
      '</div>';
  }

  function ensureOvaleSizeChartModal() {
    var overlay;
    var dialog;
    var closeButton;
    var content;

    if (ovaleSizeChartModalState && document.documentElement.contains(ovaleSizeChartModalState.overlay)) {
      return ovaleSizeChartModalState;
    }

    overlay = document.querySelector('.amour-kiwi-modal-overlay');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'amour-kiwi-modal-overlay';
      overlay.hidden = true;
      overlay.setAttribute('aria-hidden', 'true');
      overlay.setAttribute('data-ovale-size-chart-modal', '');

      dialog = document.createElement('div');
      dialog.className = 'amour-size-chart-modal';
      dialog.setAttribute('role', 'dialog');
      dialog.setAttribute('aria-modal', 'true');
      dialog.setAttribute('aria-labelledby', 'OvaleSizeChartTitle');

      closeButton = document.createElement('button');
      closeButton.type = 'button';
      closeButton.className = 'amour-size-chart-modal__close';
      closeButton.setAttribute('aria-label', 'Close size chart');
      closeButton.textContent = '\u00d7';

      content = document.createElement('div');
      content.className = 'amour-size-chart-modal__content';

      dialog.appendChild(closeButton);
      dialog.appendChild(content);
      overlay.appendChild(dialog);
      document.body.appendChild(overlay);
    } else {
      closeButton = overlay.querySelector('.amour-size-chart-modal__close');
      content = overlay.querySelector('.amour-size-chart-modal__content');
    }

    ovaleSizeChartModalState = {
      overlay: overlay,
      closeButton: closeButton,
      content: content,
      returnFocus: null,
      bodyOverflow: '',
      scrollY: 0,
      country: null,
      language: null
    };

    function closeModal() {
      var returnFocus;
      if (ovaleSizeChartModalState.overlay.hidden) return;

      returnFocus = ovaleSizeChartModalState.returnFocus;
      ovaleSizeChartModalState.overlay.hidden = true;
      ovaleSizeChartModalState.overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = ovaleSizeChartModalState.bodyOverflow;
      window.scrollTo(0, ovaleSizeChartModalState.scrollY);
      if (returnFocus && document.documentElement.contains(returnFocus)) {
        window.requestAnimationFrame(function () { returnFocus.focus({ preventScroll: true }); });
      }
    }

    closeButton.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      closeModal();
    });
    overlay.addEventListener('click', function (event) {
      if (event.target === overlay) closeModal();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !overlay.hidden) closeModal();
    });
    ovaleSizeChartModalState.close = closeModal;

    return ovaleSizeChartModalState;
  }

  function openOvaleSizeChart(trigger) {
    var config = getOvaleSizeChartConfig();
    var modalState;
    var country;
    var countrySelect;
    var preference;
    var language;

    if (!config || !config.rows || !config.rows.length) return false;

    modalState = ensureOvaleSizeChartModal();
    preference = window.amourSizeChartCountryPreference;
    language = preference ? preference.language() : '';
    if (modalState.language !== language) modalState.country = null;
    country = preference ? preference.resolve(config, function () {
      return modalState.country || getSizeChartCountry(config);
    }) : (modalState.country || getSizeChartCountry(config));
    modalState.returnFocus = trigger;
    modalState.bodyOverflow = document.body.style.overflow;
    modalState.scrollY = window.scrollY;
    modalState.country = country;
    modalState.language = language;
    modalState.closeButton.setAttribute('aria-label', config.closeLabel || 'Close size chart');
    modalState.content.innerHTML = buildOvaleSizeChart(config, country);
    modalState.content.querySelector('.amour-size-chart-modal__title').id = 'OvaleSizeChartTitle';
    modalState.overlay.hidden = false;
    modalState.overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    countrySelect = modalState.content.querySelector('[data-size-chart-country]');
    if (countrySelect) {
      countrySelect.addEventListener('change', function () {
        var countryOption = getSizeChartCountryOption(config, countrySelect.value);
        modalState.country = countrySelect.value;
        if (preference) preference.remember(config, countrySelect.value);
        modalState.content.querySelector('[data-size-chart-country-heading]').textContent = countryOption.shortLabel || countrySelect.value;
        modalState.content.querySelector('[data-size-chart-country-label]').textContent = countryOption.label || countrySelect.value;
        modalState.content.querySelector('[data-size-chart-rows]').innerHTML = buildSizeChartRows(config, countrySelect.value);
      });
    }

    window.requestAnimationFrame(function () { modalState.closeButton.focus({ preventScroll: true }); });
    return true;
  }

  function bindOvaleSizeGuide(root) {
    if (root.dataset.ovaleSizeGuideBound === 'true') return;
    root.dataset.ovaleSizeGuideBound = 'true';

    root.addEventListener('click', function (event) {
      var trigger = event.target.closest && event.target.closest('[data-size-chart-trigger]');
      if (!trigger || !root.contains(trigger)) return;
      if (openOvaleSizeChart(trigger)) {
        event.preventDefault();
        event.stopPropagation();
      }
    });

    root.addEventListener('keydown', function (event) {
      var trigger = event.target.closest && event.target.closest('[data-size-chart-trigger]');
      if (!trigger || !root.contains(trigger) || (event.key !== 'Enter' && event.key !== ' ')) return;
      if (openOvaleSizeChart(trigger)) {
        event.preventDefault();
        event.stopPropagation();
      }
    });
  }

  function initOvaleDelivery(root) {
    if (!root || root.dataset.ovaleDeliveryBound === 'true') return;
    root.dataset.ovaleDeliveryBound = 'true';

    var flag = root.querySelector('[data-ovale-country-flag]');
    var shippingIn = root.querySelector('[data-ovale-shipping-in]');
    var countryCodeText = root.querySelector('[data-ovale-country-code]');
    var countryNode = root.querySelector('[data-ovale-delivery-country]');
    var countryData = root.querySelector('[data-ovale-delivery-countries]');
    var countries = {};
    var detectedCountry = '';
    var failedFlags = {};
    var fallbackFlag = countryNode && countryNode.getAttribute('data-fallback-flag');
    var fallbackLabel = 'EU';
    try { fallbackLabel = new Intl.DisplayNames([document.documentElement.lang || 'en'], { type: 'region' }).of('EU'); } catch (error) { /* EU remains readable. */ }
    try { countries = JSON.parse(countryData.textContent); } catch (error) { /* Keep a neutral label. */ }

    function validCountry(value) {
      var code = typeof value === 'string' ? value.toUpperCase() : '';
      return /^[A-Z]{2}$/.test(code) && Object.prototype.hasOwnProperty.call(countries, code) ? code : '';
    }

    function setCountryFlag() {
      // Delivery origin follows current detection, not saved market/link preferences.
      var code = detectedCountry;
      var lowerCode = code.toLowerCase();
      var canShowFlag = code && typeof flagBs === 'object' && typeof flagBs[lowerCode] === 'string' && !failedFlags[code];
      if (!canShowFlag) code = '';
      root.dataset.ovaleDeliveryCountrySource = code ? 'detected' : 'eu-fallback';
      if (shippingIn) {
        shippingIn.hidden = false;
        shippingIn.textContent = shippingIn.getAttribute(code ? 'data-with-country' : 'data-without-country');
      }
      if (countryCodeText) countryCodeText.textContent = code || 'EU';
      if (countryNode) {
        countryNode.hidden = false;
        countryNode.style.display = '';
        if (code) {
          var label = countryNode.getAttribute('data-destination-label') || '__COUNTRY__, __CODE__';
          countryNode.setAttribute('aria-label', label.split('__COUNTRY__').join(countries[code]).split('__CODE__').join(code));
        } else countryNode.setAttribute('aria-label', fallbackLabel);
      }
      if (flag) {
        var source = code ? flagBs[lowerCode] : fallbackFlag;
        flag.dataset.deliveryFlagCountry = code;
        if (source && flag.getAttribute('src') !== source) flag.setAttribute('src', source);
        flag.hidden = !source;
      }
    }

    if (flag) flag.addEventListener('error', function () {
      var code = flag.dataset.deliveryFlagCountry;
      if (code) { failedFlags[code] = true; setCountryFlag(); }
    });

    // One first-party GeoIP request per page. Never infer a destination from language or currency.
    if (!ovaleVisitorCountryRequest) {
      ovaleVisitorCountryRequest = new Promise(function (resolve) {
        var controller = typeof AbortController === 'function' ? new AbortController() : null;
        var timer = window.setTimeout(function () {
          resolve('');
          if (controller) controller.abort();
        }, 3000);
        if (!window.fetch) { window.clearTimeout(timer); resolve(''); return; }
        var route = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
        var options = { credentials: 'same-origin', cache: 'no-store' };
        if (controller) options.signal = controller.signal;
        fetch(route + 'browsing_context_suggestions.json?country[enabled]=true&language[enabled]=false', options)
          .then(function (response) { if (!response.ok) throw new Error('Country detection unavailable'); return response.json(); })
          .then(function (data) {
            var country = data && data.detected_values && data.detected_values.country;
            resolve(country && typeof country.handle === 'string' ? country.handle : '');
          })
          .catch(function () { resolve(''); })
          .then(function () { window.clearTimeout(timer); });
      });
    }
    ovaleVisitorCountryRequest.then(function (code) {
      detectedCountry = validCountry(code);
      setCountryFlag();
    });
    var deliveryEstimate = root.querySelector('.ovale-delivery__estimate');
    var estimateClause = root.querySelector('.ovale-delivery__estimate-clause');
    var purchaseForm = root.querySelector('form[action*="/cart/add"]');
    var estimateObserver;
    var estimateTimer;
    function syncDeliveryEstimate() {
      if (!root.isConnected) { stopEstimateSync(); return; }
      var input = purchaseForm && purchaseForm.querySelector('input[name="properties[Estimated delivery between]"]');
      var range = input && !input.disabled ? String(input.value || '').trim() : '';
      if (!range && estimateClause) range = estimateClause.getAttribute('data-amour-stock-preview') || '';
      if (deliveryEstimate && deliveryEstimate.textContent !== range) deliveryEstimate.textContent = range;
      if (estimateClause) {
        estimateClause.hidden = !range;
        estimateClause.style.display = range ? '' : 'none';
      }
    }
    function stopEstimateSync() {
      if (estimateObserver) estimateObserver.disconnect();
      window.clearInterval(estimateTimer);
    }
    setCountryFlag();
    window.setTimeout(setCountryFlag, 1200);
    if (purchaseForm) {
      // Read the same resolved app value submitted with the item. Never alter it.
      estimateObserver = new MutationObserver(syncDeliveryEstimate);
      estimateObserver.observe(purchaseForm, {childList: true, subtree: true, attributes: true, attributeFilter: ['value', 'disabled', 'name']});
      purchaseForm.addEventListener('input', syncDeliveryEstimate);
      purchaseForm.addEventListener('change', syncDeliveryEstimate);
      // Programmatic input.value updates need not emit DOM mutations or events.
      estimateTimer = window.setInterval(function () { if (!document.hidden) syncDeliveryEstimate(); }, 500);
    }
    window.addEventListener('pagehide', stopEstimateSync, {once: true});
    window.addEventListener('pageshow', function (event) {
      if (!event.persisted || !purchaseForm) return;
      estimateObserver.observe(purchaseForm, {childList: true, subtree: true, attributes: true, attributeFilter: ['value', 'disabled', 'name']});
      window.clearInterval(estimateTimer);
      estimateTimer = window.setInterval(function () { if (!document.hidden) syncDeliveryEstimate(); }, 500);
      syncDeliveryEstimate();
    });
    syncDeliveryEstimate();
  }

  function initOvalePurchaseSticky(root) {
    if (!root || root.dataset.ovalePurchaseStickyBound === 'true') return;

    var purchase = root.querySelector('[data-ovale-purchase]');
    var desktopMedia = window.matchMedia && window.matchMedia('(min-width: 1024px)');
    var bottomGap = 12;
    var updateFrame = null;

    if (!purchase || !desktopMedia) return;
    root.dataset.ovalePurchaseStickyBound = 'true';

    function updateStickyTop() {
      window.cancelAnimationFrame(updateFrame);
      updateFrame = window.requestAnimationFrame(function () {
        var defaultTop;
        var purchaseHeight;
        var nextTop;

        updateFrame = null;
        purchase.style.removeProperty('top');
        if (!desktopMedia.matches) return;

        defaultTop = parseFloat(window.getComputedStyle(purchase).top);
        if (!isFinite(defaultTop)) defaultTop = 0;

        purchaseHeight = purchase.getBoundingClientRect().height;
        nextTop = Math.min(defaultTop, window.innerHeight - purchaseHeight - bottomGap);
        purchase.style.top = Math.floor(nextTop) + 'px';
      });
    }

    if (window.ResizeObserver) {
      new ResizeObserver(updateStickyTop).observe(purchase);
    }
    window.addEventListener('resize', updateStickyTop, { passive: true });
    if (desktopMedia.addEventListener) desktopMedia.addEventListener('change', updateStickyTop);
    else if (desktopMedia.addListener) desktopMedia.addListener(updateStickyTop);

    window.requestAnimationFrame(updateStickyTop);
    window.setTimeout(updateStickyTop, 1500);
  }

  function initOvalePdp(root) {
    if (root.dataset.ovalePdpBound === 'true') return;

    var dataNode = root.querySelector('[data-ovale-product-json]');
    var form = root.querySelector('form.ovale-form');
    if (!dataNode || !form) return;

    root.dataset.ovalePdpBound = 'true';

    bindOvaleSizeGuide(root);

    var product;
    try {
      product = JSON.parse(dataNode.textContent);
    } catch (error) {
      return;
    }

    var titleNode = root.querySelector('.ovale-purchase__title');
    var protectTorsadeTitle = (root.getAttribute('data-pdp-profile') === 'torsade' || root.getAttribute('data-pdp-profile') === 'laureole-ovale' || root.getAttribute('data-pdp-profile') === 'flocon' || root.getAttribute('data-pdp-profile') === 'lemeraude' || root.getAttribute('data-pdp-profile') === 'le-luxe' || root.getAttribute('data-pdp-profile') === 'promesse' || root.getAttribute('data-pdp-profile') === 'ailes');
    var stableTitle = protectTorsadeTitle && titleNode ? titleNode.textContent.trim() : (product.title || '');
    var stableTitleMarkup = titleNode ? titleNode.innerHTML : '';
    function restoreStableTitle() {
      if (protectTorsadeTitle) {
        if (titleNode && (titleNode.textContent.trim() !== stableTitle || !titleNode.querySelector('[data-amour-ring-title]'))) titleNode.innerHTML = stableTitleMarkup;
      } else if (titleNode && titleNode.textContent.trim() !== stableTitle) titleNode.textContent = stableTitle;
    }
    restoreStableTitle();
    if (titleNode && window.MutationObserver) {
      new MutationObserver(restoreStableTitle).observe(titleNode, { childList: true, characterData: true, subtree: true });
    }

    var variants = product.variants || [];
    var groups = Array.prototype.slice.call(form.querySelectorAll('[data-ovale-option-group]'));
    var hiddenId = form.querySelector('[data-ovale-variant-id]');
    var sizeSelect = form.querySelector('[data-ovale-size-select]');
    var sizeError = form.querySelector('[data-ovale-size-error]');
    var sizePicker = form.querySelector('[data-ovale-size-picker]');
    var sizeTrigger = form.querySelector('[data-ovale-size-trigger]');
    var sizeValue = form.querySelector('[data-ovale-size-value]');
    var sizeListbox = form.querySelector('[data-ovale-size-listbox]');
    var sizeOptions = Array.prototype.slice.call(form.querySelectorAll('[data-ovale-size-option]'));
    var customLengthField = form.querySelector('[data-ovale-custom-length-field]');
    var customLengthInput = form.querySelector('[data-ovale-custom-length]');
    var addButton = form.querySelector('[data-ovale-atc]');
    var specificationNode = root.querySelector('[data-ovale-specification]');
    var infoTriggers = Array.prototype.slice.call(form.querySelectorAll('[data-ovale-info-trigger]'));
    var assuranceAnchor = form.querySelector('[data-ovale-assurance-anchor]');
    var stickyAssurance = form.querySelector('[data-ovale-assurance-sticky]');
    var visualCarat = root.querySelector('[data-ovale-visual-carat]');
    var visualCaratImage = root.querySelector('[data-ovale-visual-carat-image]');
    var visualCaratDimension = root.querySelector('[data-ovale-visual-carat-dimension]');
    var visualCaratButtons = Array.prototype.slice.call(root.querySelectorAll('[data-ovale-visual-carat-option]'));
    var pdpProfile = root.getAttribute('data-pdp-profile') || 'shared';
    var dynamicGalleryFigure = root.querySelector('[data-profile-dynamic-gallery="ring-size"]');
    var dynamicGalleryImage = dynamicGalleryFigure && dynamicGalleryFigure.querySelector('.ovale-gallery__image');
    var dynamicGalleryTrigger = dynamicGalleryFigure && dynamicGalleryFigure.querySelector('[data-ovale-lightbox-trigger]');
    var selected = [];
    var explicitVariant = null;
    var initialMoneyText = (root.querySelector('[data-ovale-price]') || {}).textContent || '';
    var parameters = new URLSearchParams(window.location.search);
    var variantParameter = parameters.get('variant');
    var ailesPair = root.hasAttribute('data-ailes-pair');
    var lemeraudePair = root.hasAttribute('data-lemeraude-pair') || ailesPair;
    var lemeraudeChooseSize = lemeraudePair && parameters.get('choose_size') === '1';

    infoTriggers.forEach(function (infoTrigger) {
      var infoId = infoTrigger.getAttribute('aria-controls');
      var infoPopover = infoId ? document.getElementById(infoId) : null;
      if (!infoPopover) return;

      function closeInfo(returnFocus) {
        if (infoPopover.hidden) return;
        infoPopover.hidden = true;
        infoTrigger.setAttribute('aria-expanded', 'false');
        if (returnFocus) infoTrigger.focus({ preventScroll: true });
      }

      function openInfo() {
        infoTriggers.forEach(function (otherTrigger) {
          var otherId = otherTrigger.getAttribute('aria-controls');
          var otherPopover = otherId ? document.getElementById(otherId) : null;
          if (otherTrigger !== infoTrigger && otherPopover && !otherPopover.hidden) {
            otherPopover.hidden = true;
            otherTrigger.setAttribute('aria-expanded', 'false');
          }
        });
        infoPopover.hidden = false;
        infoTrigger.setAttribute('aria-expanded', 'true');
        window.requestAnimationFrame(function () { infoPopover.focus({ preventScroll: true }); });
      }

      infoTrigger.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (infoPopover.hidden) openInfo();
        else closeInfo(true);
      });
      infoTrigger.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        if (infoPopover.hidden) openInfo();
        else closeInfo(true);
      });
      document.addEventListener('click', function (event) {
        if (infoPopover.hidden || infoPopover.contains(event.target) || infoTrigger.contains(event.target)) return;
        closeInfo(false);
      });
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && !infoPopover.hidden) {
          event.preventDefault();
          closeInfo(true);
        }
      });
    });

    if (assuranceAnchor && stickyAssurance) {
      var stickyMedia = window.matchMedia('(max-width: 749px)');
      var updateStickyAssurance = function () {
        var anchorRect = assuranceAnchor.getBoundingClientRect();
        var previewBar = document.getElementById('PBarNextFrameWrapper');
        var shouldShow = stickyMedia.matches && anchorRect.top > window.innerHeight;
        var stickyBottom = 'env(safe-area-inset-bottom, 0px)';
        if (previewBar) {
          var previewRect = previewBar.getBoundingClientRect();
          var visiblePreviewHeight = Math.max(0, window.innerHeight - previewRect.top);
          if (visiblePreviewHeight > 0) {
            stickyBottom = 'calc(' + Math.ceil(visiblePreviewHeight) + 'px + env(safe-area-inset-bottom, 0px))';
          }
        }
        stickyAssurance.style.setProperty('--ovale-sticky-assurance-bottom', stickyBottom);
        stickyAssurance.classList.toggle('is-visible', shouldShow);
      };
      if (window.IntersectionObserver) {
        new IntersectionObserver(updateStickyAssurance, { threshold: [0, .01] }).observe(assuranceAnchor);
      }
      var stickyScrollFrame = null;
      window.addEventListener('scroll', function () {
        if (stickyScrollFrame) return;
        stickyScrollFrame = window.requestAnimationFrame(function () {
          stickyScrollFrame = null;
          updateStickyAssurance();
        });
      }, { passive: true });
      window.addEventListener('resize', updateStickyAssurance, { passive: true });
      window.requestAnimationFrame(updateStickyAssurance);
      window.setTimeout(updateStickyAssurance, 1500);
    }

    if (variantParameter) {
      explicitVariant = variants.find(function (variant) {
        return String(variant.id) === String(variantParameter);
      }) || null;
    }

    function isPlaceholderValue(value) {
      return /^select\b/i.test(String(value || '').trim());
    }

    function isPlaceholderVariant(variant) {
      return variant && variant.options && variant.options.some(isPlaceholderValue);
    }

    function formatMoney(cents) {
      var sample = String(initialMoneyText || '').trim();
      var firstDigit = sample.search(/\d/);
      var lastDigit = Math.max(sample.lastIndexOf('0'), sample.lastIndexOf('1'), sample.lastIndexOf('2'), sample.lastIndexOf('3'), sample.lastIndexOf('4'), sample.lastIndexOf('5'), sample.lastIndexOf('6'), sample.lastIndexOf('7'), sample.lastIndexOf('8'), sample.lastIndexOf('9'));
      if (firstDigit >= 0 && lastDigit >= firstDigit) {
        var prefix = sample.slice(0, firstDigit);
        var suffix = sample.slice(lastDigit + 1);
        var numericSample = sample.slice(firstDigit, lastDigit + 1);
        var decimalMatch = numericSample.match(/([.,])(\d{2})$/);
        var decimalSeparator = decimalMatch ? decimalMatch[1] : '.';
        var thousandsSeparator = decimalSeparator === ',' ? '.' : ',';
        var fixed = (Number(cents || 0) / 100).toFixed(decimalMatch ? 2 : 0).split('.');
        var integer = fixed[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparator);
        return prefix + integer + (decimalMatch ? decimalSeparator + fixed[1] : '') + suffix;
      }
      return (Number(cents || 0) / 100).toLocaleString(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: root.getAttribute('data-currency-code') || 'EUR'
      });
    }

    function getGroup(index) {
      return groups.find(function (group) {
        return Number(group.getAttribute('data-option-index')) === index;
      });
    }

    function inferOptionRole(name, values) {
      var normalizedName = String(name || '').trim().toLowerCase().replace(/:$/, '');
      var normalizedValues = (values || []).map(function (value) {
        return String(value || '').trim().toLowerCase();
      });
      if (/gemstone/.test(normalizedName) || normalizedValues.some(function (value) { return /moissanite|lab[- ]grown diamond/.test(value); })) return 'gemstone';
      if (/carat|karat|quilat|carati|karaat/.test(normalizedName) || normalizedValues.some(function (value) { return value.indexOf(' ct') !== -1; })) return 'carat';
      if (/metal|metall|métal|metallo|metaal/.test(normalizedName) || normalizedValues.some(function (value) { return /platinum|gold/.test(value); })) return 'metal';
      if (/size|taglia|talla|taille|größe|grösse|maat|størrelse/.test(normalizedName) || normalizedValues.some(function (value) { return /^(eu|uk)\s|adjust|custom size|select your ring size/.test(value); })) return 'size';
      return normalizedName;
    }

    function displaySize(value) {
      var label = String(value || '');
      return label
        .replace('SIZE-ADJUSTABLE (Fits any size)', root.getAttribute('data-label-size-adjustable') || 'SIZE-ADJUSTABLE (Fits any size)')
        .replace('Custom Size (made-to-order)', root.getAttribute('data-label-size-custom') || 'Custom Size (made-to-order)');
    }
    sizeOptions.forEach(function (option) { if (!option.hasAttribute('data-confirm-size-later-option')) option.textContent = displaySize(option.getAttribute('data-ovale-size-option')); });
    if (sizeSelect) Array.prototype.forEach.call(sizeSelect.options, function (option) { if (option.value) option.textContent = displaySize(option.value); });
    function setSizePickerValue(value) {
      var confirmLater = form.dataset.confirmSizeLater === 'true';
      var label = confirmLater ? (root.getAttribute('data-label-confirm-size-later') || 'I will confirm the size later') : (value || root.getAttribute('data-label-select-size') || 'Select your ring size');
      label = displaySize(label);
      if (/^custom size/i.test(label)) label = label.split('(')[0].trim();
      if (sizeValue) sizeValue.textContent = label;
      sizeOptions.forEach(function (option) {
        var isConfirmOption = option.hasAttribute('data-confirm-size-later-option');
        var active = confirmLater ? isConfirmOption : (!isConfirmOption && option.getAttribute('data-ovale-size-option') === value);
        option.setAttribute('aria-selected', String(active));
        option.classList.toggle('is-active', active);
      });
    }
    function syncCustomLength() {
      if (!customLengthField || !customLengthInput) return;
      var custom = /^custom size/i.test(sizeSelect && sizeSelect.value || '');
      customLengthField.hidden = !custom;
      customLengthInput.disabled = !custom;
      customLengthInput.required = custom;
    }

    function closeSizePicker(returnFocus) {
      if (!sizeListbox || sizeListbox.hidden) return;
      sizeListbox.hidden = true;
      sizePicker.classList.remove('is-open', 'is-open-upward');
      sizeTrigger.setAttribute('aria-expanded', 'false');
      if (returnFocus) sizeTrigger.focus({ preventScroll: true });
    }

    function positionSizePicker() {
      var viewportHeight;
      var triggerRect;
      var listHeight;
      var spaceAbove;
      var spaceBelow;
      var safeEdge = 12;

      sizePicker.classList.remove('is-open-upward');
      if (!window.matchMedia || !window.matchMedia('(min-width: 1024px)').matches) return;

      viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      triggerRect = sizeTrigger.getBoundingClientRect();
      listHeight = sizeListbox.offsetHeight;
      spaceAbove = triggerRect.top - safeEdge;
      spaceBelow = viewportHeight - triggerRect.bottom - safeEdge;

      if (listHeight > spaceBelow && spaceAbove > spaceBelow) {
        sizePicker.classList.add('is-open-upward');
      }
    }

    function openSizePicker() {
      var activeOption;
      if (!sizeListbox) return;
      sizeListbox.hidden = false;
      sizePicker.classList.add('is-open');
      positionSizePicker();
      sizeTrigger.setAttribute('aria-expanded', 'true');
      activeOption = sizeOptions.find(function (option) {
        return option.getAttribute('aria-selected') === 'true';
      }) || sizeOptions[0];
      if (activeOption) window.requestAnimationFrame(function () { activeOption.focus({ preventScroll: true }); });
    }

    function chooseSize(option) {
      var value = option.getAttribute('data-ovale-size-option');
      if (option.hasAttribute('data-confirm-size-later-option')) form.dataset.confirmSizeLater = 'true';
      else delete form.dataset.confirmSizeLater;
      sizeSelect.value = value;
      setSizePickerValue(value);
      sizeSelect.dispatchEvent(new Event('change', { bubbles: true }));
      closeSizePicker(true);
    }

    function syncVisualCarat(value) {
      var activeButton = visualCaratButtons.find(function (button) {
        return button.getAttribute('data-ovale-visual-carat-option') === value;
      });
      var caratIndex = activeButton && activeButton.getAttribute('data-ovale-visual-carat-index');
      if (!caratIndex) caratIndex = value === '2.0 CT' ? '2' : '1';
      if (visualCaratImage) {
        visualCaratImage.src = visualCaratImage.getAttribute('data-carat-image-' + caratIndex);
        visualCaratImage.alt = visualCaratImage.getAttribute('data-carat-alt-' + caratIndex) || (caratIndex === '2' ? 'Two carat Ovale ring shown on the same hand' : 'One carat Ovale ring shown on hand');
      }
      if (visualCaratDimension) visualCaratDimension.textContent = (visualCaratImage && visualCaratImage.getAttribute('data-carat-dimension-' + caratIndex)) || (caratIndex === '2' ? 'Approx. 10 × 7 mm' : 'Approx. 8 × 6 mm');
      visualCaratButtons.forEach(function (button) {
        var active = button.getAttribute('data-ovale-visual-carat-option') === value;
        button.classList.toggle('is-selected', active);
        button.setAttribute('aria-pressed', String(active));
        if ((pdpProfile === 'torsade' || pdpProfile === 'laureole-ovale' || pdpProfile === 'flocon' || pdpProfile === 'lemeraude' || pdpProfile === 'le-luxe' || pdpProfile === 'promesse' || pdpProfile === 'ailes') || pdpProfile === 'amour' || pdpProfile === 'lumiere' || pdpProfile === 'fiancee' || pdpProfile === 'eternite' || pdpProfile === 'naturel' || pdpProfile === 'enigme' || pdpProfile === 'princesse' || (pdpProfile === 'la-couronne' || pdpProfile === 'clarte-royale')) button.setAttribute('tabindex', active ? '0' : '-1');
      });
    }

    function syncProfileGalleryForSize(value) {
      if (!dynamicGalleryFigure || !dynamicGalleryImage || pdpProfile !== 'fiancee') return;
      var adjustable = /adjustable|größenverstellbar/i.test(String(value || ''));
      var prefix = adjustable ? 'alternate' : 'default';
      var source = dynamicGalleryFigure.getAttribute('data-profile-' + prefix + '-src');
      var alt = dynamicGalleryFigure.getAttribute('data-profile-' + prefix + '-alt') || product.title;
      if (!source) return;
      dynamicGalleryImage.src = source;
      dynamicGalleryImage.alt = alt;
      if (dynamicGalleryTrigger) {
        dynamicGalleryTrigger.setAttribute('data-ovale-lightbox-src', source);
        dynamicGalleryTrigger.setAttribute('data-ovale-lightbox-alt', alt);
      }
    }

    function findVariant(requireSize) {
      return variants.find(function (variant) {
        if (requireSize && isPlaceholderVariant(variant)) return false;
        return variant.options.every(function (value, index) {
          if (!selected[index]) return isPlaceholderValue(value);
          return value === selected[index];
        });
      }) || null;
    }

    function findDisplayVariant() {
      return variants.find(function (variant) {
        return variant.options.every(function (value, index) {
          if (!selected[index]) return true;
          return value === selected[index];
        });
      }) || variants[0];
    }

    function setUrl(variant) {
      var url = new URL(window.location.href);
      if (variant) {
        url.searchParams.set('variant', variant.id);
        if (lemeraudePair) url.searchParams.delete('choose_size');
      } else {
        url.searchParams.delete('variant');
      }
      window.history.replaceState({ variantId: variant ? variant.id : null }, '', url.pathname + url.search + url.hash);
    }

    function setButtonState(variant) {
      var label = addButton.querySelector('[data-ovale-atc-label]');
      var addLabel = root.getAttribute('data-label-add-to-cart') || 'ADD TO CART';
      var soldOutLabel = root.getAttribute('data-label-sold-out') || 'SOLD OUT';
      var unavailableLabel = root.getAttribute('data-label-unavailable') || 'UNAVAILABLE';
      addButton.removeAttribute('disabled');
      if (sizeSelect && !sizeSelect.value) {
        label.textContent = addLabel;
      } else if (!variant || !variant.available) {
        label.textContent = variant ? soldOutLabel : unavailableLabel;
        addButton.setAttribute('disabled', 'disabled');
      } else {
        label.textContent = addLabel;
      }
    }

    function updatePrice(variant) {
      if (!variant) return;
      var current = root.querySelector('[data-ovale-price]');
      var compare = root.querySelector('[data-ovale-compare-price]');
      var klarna = root.querySelector('[data-ovale-klarna]');
      current.textContent = formatMoney(variant.price);
      klarna.textContent = formatMoney(Math.round(variant.price / 3));
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compare.textContent = formatMoney(variant.compare_at_price);
        compare.hidden = false;
      } else {
        compare.textContent = '';
        compare.hidden = true;
      }
    }

    function updateSpecs() {
      var currentMetal = '';
      var currentCarat = '';
      var currentSize = '';
      var currentGemstone = root.getAttribute('data-current-spec-gemstone') || '';
      groups.forEach(function (group) {
        var index = Number(group.getAttribute('data-option-index'));
        var role = group.getAttribute('data-option-role') || inferOptionRole(group.getAttribute('data-option-name'), [selected[index]]);
        var value = selected[index] || root.getAttribute('data-label-select-size') || 'Select your ring size';
        var target;
        if (role === 'carat') {
          target = root.querySelector('[data-ovale-spec-carat]');
          currentCarat = selected[index] || '';
        }
        if (role === 'metal') {
          target = root.querySelector('[data-ovale-spec-metal]');
          currentMetal = selected[index] || '';
          if (pdpProfile === 'lumiere' || pdpProfile === 'fiancee' || pdpProfile === 'ovale' || (pdpProfile === 'torsade' || pdpProfile === 'laureole-ovale' || pdpProfile === 'flocon' || pdpProfile === 'lemeraude' || pdpProfile === 'le-luxe' || pdpProfile === 'promesse' || pdpProfile === 'ailes')) {
            if (currentMetal === 'Platinum 950') currentMetal = root.getAttribute('data-label-metal-platinum') || currentMetal;
            else if (currentMetal === '18K White Gold') currentMetal = root.getAttribute('data-label-metal-white-gold') || currentMetal;
            value = currentMetal;
          }
        }
        if (role === 'size') {
          target = root.querySelector('[data-ovale-spec-size]');
          currentSize = selected[index] || '';
          value = displaySize(value);
          if (form.dataset.confirmSizeLater === 'true') value = root.getAttribute('data-label-confirm-size-later') || 'I will confirm the size later';
        }
        if (role === 'gemstone') {
          var normalizedGemstone = String(selected[index] || '').toLowerCase();
          if (normalizedGemstone.indexOf('moissanite') !== -1) currentGemstone = root.getAttribute('data-label-spec-moissanite') || 'Brilliant Moissanite';
          else if (normalizedGemstone.indexOf('diamond') !== -1) currentGemstone = root.getAttribute('data-label-spec-lab') || 'Lab-Grown Diamond';
          else currentGemstone = String(selected[index] || '').replace(/\s*\([^)]*\)\s*$/, '');
          target = root.querySelector('[data-ovale-spec-gemstone]');
          value = currentGemstone;
          root.setAttribute('data-current-spec-gemstone', currentGemstone);
          var certification = root.querySelector('[data-ovale-certification]');
          if (certification && /moissanite|diamond/.test(normalizedGemstone)) {
            var certificationType = normalizedGemstone.indexOf('moissanite') !== -1 ? 'moissanite' : 'lab';
            certification.querySelector('summary small').textContent = certification.getAttribute('data-' + certificationType + '-summary');
            certification.querySelector('.ovale-documentation-copy p').textContent = certification.getAttribute('data-' + certificationType + '-body');
            var certificationNote = certification.closest('.ovale-specifications').querySelector('.ovale-specifications__note');
            if (certificationNote) certificationNote.textContent = certification.getAttribute('data-' + certificationType + '-note');
          }
        }
        if (target) target.textContent = value;
      });
      if (root.hasAttribute('data-jewellery-pdp') && currentSize) {
        root.querySelectorAll('[data-ovale-spec-size]').forEach(function (target) {
          target.textContent = displaySize(currentSize);
        });
      }
      if (specificationNode) {
        specificationNode.textContent = (currentGemstone ? currentGemstone.toUpperCase() + ' · ' : '') + currentMetal.toUpperCase();
      }

      var isTwoCarat = currentCarat === '2.0 CT';
      var isThreeCarat = currentCarat === '3.0 CT';
      var dimension = root.querySelector('[data-ovale-spec-dimensions]');
      var gemSummary = root.querySelector('[data-ovale-spec-gem-summary]');
      var ringSummary = root.querySelector('[data-ovale-spec-ring-summary]');
      var colour = root.querySelector('[data-ovale-spec-colour]');
      var clarity = root.querySelector('[data-ovale-spec-clarity]');
      var construction = root.querySelector('[data-ovale-spec-construction]');
      if ((pdpProfile === 'torsade' || pdpProfile === 'laureole-ovale' || pdpProfile === 'flocon' || pdpProfile === 'lemeraude' || pdpProfile === 'le-luxe' || pdpProfile === 'promesse' || pdpProfile === 'ailes')) {
        if (dimension) dimension.textContent = root.getAttribute(isTwoCarat ? 'data-spec-dimensions-2' : 'data-spec-dimensions-1') || '';
        if (gemSummary && pdpProfile !== 'flocon') gemSummary.textContent = root.getAttribute('data-spec-shape-summary') + ' · ' + currentCarat;
        if (ringSummary) {
          var torsadeMetal = ringSummary.querySelector('[data-ovale-spec-ring-metal]');
          if (torsadeMetal) torsadeMetal.textContent = currentMetal;
        }
      } else if (pdpProfile === 'enigme' || pdpProfile === 'princesse' || (pdpProfile === 'la-couronne' || pdpProfile === 'clarte-royale')) {
        if (dimension) dimension.textContent = root.getAttribute(isTwoCarat ? 'data-spec-dimensions-2' : 'data-spec-dimensions-1') || '';
        if (gemSummary) gemSummary.textContent = (root.getAttribute('data-spec-shape-summary') || 'Round brilliant') + ' · ' + (currentCarat || '1.0 CT');
        if (ringSummary) ringSummary.textContent = (currentMetal || 'Platinum 950') + ' · ' + (root.getAttribute('data-spec-setting-summary') || (pdpProfile === 'la-couronne' ? 'Four-prong centre setting' : 'Six-prong centre setting'));
        if (colour) colour.textContent = root.getAttribute(isTwoCarat ? 'data-spec-colour-2' : 'data-spec-colour-1') || '';
        if (clarity) clarity.textContent = root.getAttribute(isTwoCarat ? 'data-spec-clarity-2' : 'data-spec-clarity-1') || '';
        if (construction) {
          if (!currentSize) construction.textContent = (pdpProfile === 'la-couronne' || pdpProfile === 'clarte-royale') ? (root.getAttribute('data-spec-construction-unselected') || '') : 'Size-adjustable or fixed made-to-order, according to the selected size option';
          else if (/adjust|größenverstellbar/i.test(currentSize)) construction.textContent = (pdpProfile === 'la-couronne' || pdpProfile === 'clarte-royale') ? (root.getAttribute('data-spec-construction-adjustable') || 'Size-adjustable') : 'Size-adjustable';
          else construction.textContent = (pdpProfile === 'la-couronne' || pdpProfile === 'clarte-royale') ? (root.getAttribute('data-spec-construction-fixed') || 'Fixed made-to-order') : 'Fixed made-to-order';
        }
      } else if (pdpProfile === 'amour' || pdpProfile === 'lumiere' || pdpProfile === 'fiancee') {
        if (dimension) dimension.textContent = root.getAttribute(isThreeCarat ? 'data-spec-dimensions-3' : (isTwoCarat ? 'data-spec-dimensions-2' : 'data-spec-dimensions-1')) || '';
        if (gemSummary) gemSummary.textContent = (root.getAttribute('data-spec-shape-summary') || 'Round brilliant') + ' · ' + (currentCarat || (pdpProfile === 'lumiere' ? '2.0 CT' : '1.0 CT'));
        if (ringSummary) ringSummary.textContent = (currentMetal || 'Platinum 950') + ' · ' + (root.getAttribute('data-spec-setting-summary') || 'Six-prong crown');
      } else if (pdpProfile === 'shared' || pdpProfile === 'naturel' || pdpProfile === 'le-luxe' || pdpProfile === 'promesse' || pdpProfile === 'ailes') {
        if (gemSummary) gemSummary.textContent = currentGemstone + (currentCarat ? ' · ' + currentCarat : '');
        if (ringSummary) ringSummary.textContent = (currentMetal || 'Platinum 950') + ' · ' + (root.getAttribute('data-spec-product-title') || product.title || '');
      } else {
        if (dimension) dimension.textContent = root.getAttribute(isTwoCarat ? 'data-spec-dimensions-2' : 'data-spec-dimensions-1') || (isTwoCarat ? 'Approx. 10 × 7 mm' : 'Approx. 8 × 6 mm');
        if (gemSummary) gemSummary.textContent = (root.getAttribute('data-spec-shape-summary') || 'Oval brilliant') + ' · ' + (currentCarat || '1.0 CT');
        if (ringSummary) ringSummary.textContent = (currentMetal || 'Platinum 950') + ' · ' + (root.getAttribute('data-spec-setting-summary') || 'Four-prong setting');
      }
      if (pdpProfile !== 'enigme' && pdpProfile !== 'princesse' && pdpProfile !== 'la-couronne' && pdpProfile !== 'clarte-royale') {
        if (colour) colour.textContent = 'D–F';
        if (clarity) clarity.textContent = 'VVS1–VVS2';
      }
      if (root.hasAttribute('data-jewellery-pdp')) {
        root.querySelectorAll('[data-jewellery-spec-block]').forEach(function (block) {
          var role = block.getAttribute('data-jewellery-spec-block');
          var value = block.getAttribute('data-jewellery-spec-value');
          block.hidden = role === 'metal' ? value !== currentMetal : (value === 'lab') !== /diamond/i.test(selected[0] || '');
        });
      }
      syncProfileGalleryForSize(currentSize);
      if (pdpProfile !== 'torsade' && pdpProfile !== 'laureole-ovale' && pdpProfile !== 'clarte-royale' && pdpProfile !== 'amour' && pdpProfile !== 'lumiere' && pdpProfile !== 'fiancee' && pdpProfile !== 'eternite') syncVisualCarat(currentCarat || '1.0 CT');
    }

    function updateState(options) {
      options = options || {};
      var realVariant = (!sizeSelect || sizeSelect.value) ? findVariant(true) : null;
      var displayVariant = realVariant || findDisplayVariant();
      hiddenId.value = realVariant ? realVariant.id : '';
      updatePrice(displayVariant);
      updateSpecs();
      setButtonState(realVariant);
      if (!options.keepUrl) setUrl(realVariant || displayVariant);
      root.dispatchEvent(new CustomEvent('ovale:variant:change', { detail: { variant: realVariant, displayVariant: displayVariant } }));
    }

    groups.forEach(function (group) {
      var index = Number(group.getAttribute('data-option-index'));
      var buttons = Array.prototype.slice.call(group.querySelectorAll('[data-ovale-option-value-button]'));
      var valueLabel = group.querySelector('legend [data-ovale-option-value]');

      if (buttons.length) {
        var initialValue = explicitVariant ? explicitVariant.options[index] : buttons[0].getAttribute('data-ovale-option-value-button');
        selected[index] = initialValue;
        buttons.forEach(function (button) {
          var isSelected = button.getAttribute('data-ovale-option-value-button') === initialValue;
          button.classList.toggle('is-selected', isSelected);
          button.setAttribute('aria-pressed', String(isSelected));
          button.addEventListener('click', function () {
            selected[index] = button.getAttribute('data-ovale-option-value-button');
            buttons.forEach(function (item) {
              var active = item === button;
              item.classList.toggle('is-selected', active);
              item.setAttribute('aria-pressed', String(active));
            });
            if (valueLabel) valueLabel.textContent = selected[index];
            clearSizeError();
            updateState();
          });
        });
        if (valueLabel) valueLabel.textContent = initialValue;
      }

      if (sizeSelect && group.contains(sizeSelect)) {
        var adjustableSizeOption = sizeOptions.find(function (option) {
          return !option.hasAttribute('data-confirm-size-later-option') &&
            /adjust|größenverstellbar/i.test(option.getAttribute('data-ovale-size-option') || '');
        });
        selected[index] = explicitVariant
          ? (isPlaceholderValue(explicitVariant.options[index]) ? '' : explicitVariant.options[index])
          : (adjustableSizeOption ? adjustableSizeOption.getAttribute('data-ovale-size-option') : '');
        if (lemeraudeChooseSize) selected[index] = '';
        sizeSelect.value = selected[index];
        sizeSelect.addEventListener('change', function () {
          selected[index] = sizeSelect.value;
          if (sizeSelect) setSizePickerValue(sizeSelect.value);
          syncCustomLength();
          clearSizeError();
          updateState();
        });
      }
    });

    if (sizeSelect) setSizePickerValue(sizeSelect.value);
    syncCustomLength();
    if (lemeraudeChooseSize) {
      sizeError.hidden = false;
      sizeSelect.setAttribute('aria-invalid', 'true');
      if (sizeTrigger) sizeTrigger.setAttribute('aria-invalid', 'true');
    }

    if (sizeTrigger && sizeListbox) {
      sizeTrigger.addEventListener('click', function () {
        if (sizeListbox.hidden) openSizePicker();
        else closeSizePicker(true);
      });
      sizeTrigger.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp' || event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          openSizePicker();
        }
      });

      sizeOptions.forEach(function (option) {
        option.addEventListener('click', function () {
          chooseSize(option);
        });
        option.addEventListener('keydown', function (event) {
          var currentIndex = sizeOptions.indexOf(option);
          var nextIndex = currentIndex;
          if (event.key === 'ArrowDown') nextIndex = Math.min(sizeOptions.length - 1, currentIndex + 1);
          if (event.key === 'ArrowUp') nextIndex = Math.max(0, currentIndex - 1);
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = sizeOptions.length - 1;
          if (event.key === 'Escape') {
            event.preventDefault();
            closeSizePicker(true);
            return;
          }
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            chooseSize(option);
            return;
          }
          if (nextIndex !== currentIndex) {
            event.preventDefault();
            sizeOptions[nextIndex].focus({ preventScroll: true });
          }
        });
      });

      document.addEventListener('click', function (event) {
        if (!sizePicker.contains(event.target)) closeSizePicker(false);
      });

      window.addEventListener('resize', function () {
        if (!sizeListbox.hidden) positionSizePicker();
      }, { passive: true });
    }

    visualCaratButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var value = button.getAttribute('data-ovale-visual-carat-option');
        syncVisualCarat(value);
      });
      if ((pdpProfile === 'torsade' || pdpProfile === 'laureole-ovale' || pdpProfile === 'flocon' || pdpProfile === 'lemeraude' || pdpProfile === 'le-luxe' || pdpProfile === 'promesse' || pdpProfile === 'ailes') || pdpProfile === 'amour' || pdpProfile === 'lumiere' || pdpProfile === 'fiancee' || pdpProfile === 'eternite' || pdpProfile === 'naturel' || pdpProfile === 'enigme' || pdpProfile === 'princesse' || (pdpProfile === 'la-couronne' || pdpProfile === 'clarte-royale')) {
        button.addEventListener('keydown', function (event) {
          var currentIndex = visualCaratButtons.indexOf(button);
          var nextIndex = currentIndex;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (currentIndex + 1) % visualCaratButtons.length;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (currentIndex - 1 + visualCaratButtons.length) % visualCaratButtons.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = visualCaratButtons.length - 1;
          if (nextIndex === currentIndex) return;
          event.preventDefault();
          syncVisualCarat(visualCaratButtons[nextIndex].getAttribute('data-ovale-visual-carat-option'));
          visualCaratButtons[nextIndex].focus();
        });
      }
    });

    if (pdpProfile === 'eternite' && visualCaratButtons.length) {
      syncVisualCarat(visualCaratButtons[0].getAttribute('data-ovale-visual-carat-option'));
    }

    if (pdpProfile === 'amour' || pdpProfile === 'lumiere' || pdpProfile === 'fiancee' || pdpProfile === 'naturel' || pdpProfile === 'enigme' || pdpProfile === 'princesse' || (pdpProfile === 'la-couronne' || pdpProfile === 'clarte-royale')) {
      var comparisonLink = root.querySelector('.ovale-option__comparison-link[href^="#"]');
      var comparisonHeading = comparisonLink && document.querySelector(comparisonLink.getAttribute('href'));
      if (comparisonLink && comparisonHeading) {
        comparisonLink.addEventListener('click', function () {
          window.requestAnimationFrame(function () { comparisonHeading.focus({ preventScroll: true }); });
        });
      }
    }

    var confidenceRoot = root.querySelector('[data-ovale-size-confidence]');
    if (confidenceRoot) {
      var confidenceButtons = Array.prototype.slice.call(confidenceRoot.querySelectorAll('[data-ovale-size-confidence-option]'));
      var confidencePanels = Array.prototype.slice.call(confidenceRoot.querySelectorAll('[data-ovale-size-confidence-panel]'));
      function selectConfidence(button, moveFocus) {
        var selectedValue = button.getAttribute('data-ovale-size-confidence-option');
        confidenceButtons.forEach(function (item) {
          var active = item === button;
          item.classList.toggle('is-selected', active);
          item.setAttribute('aria-selected', String(active));
          item.setAttribute('tabindex', active ? '0' : '-1');
        });
        confidencePanels.forEach(function (panel) {
          panel.hidden = panel.getAttribute('data-ovale-size-confidence-panel') !== selectedValue;
        });
        if (moveFocus) button.focus();
      }
      confidenceButtons.forEach(function (button, index) {
        button.addEventListener('click', function () { selectConfidence(button); });
        button.addEventListener('keydown', function (event) {
          var nextIndex = index;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % confidenceButtons.length;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (index - 1 + confidenceButtons.length) % confidenceButtons.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = confidenceButtons.length - 1;
          if (nextIndex !== index) {
            event.preventDefault();
            selectConfidence(confidenceButtons[nextIndex], true);
          }
        });
      });
    }

    function clearSizeError() {
      if (!sizeSelect || !sizeSelect.value) return;
      sizeSelect.removeAttribute('aria-invalid');
      if (sizeTrigger) sizeTrigger.removeAttribute('aria-invalid');
      sizeError.hidden = true;
    }

    function requireSize(event) {
      if (customLengthInput && !customLengthInput.disabled && !customLengthInput.checkValidity()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        customLengthInput.focus();
        customLengthInput.reportValidity();
        return false;
      }
      if (!sizeSelect || sizeSelect.value) return true;
      event.preventDefault();
      event.stopImmediatePropagation();
      hiddenId.value = '';
      sizeSelect.setAttribute('aria-invalid', 'true');
      if (sizeTrigger) sizeTrigger.setAttribute('aria-invalid', 'true');
      sizeError.hidden = false;
      (sizeTrigger || sizeSelect).scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
      window.setTimeout(function () { (sizeTrigger || sizeSelect).focus({ preventScroll: true }); }, 350);
      return false;
    }

    form.addEventListener('submit', requireSize, true);
    root.addEventListener('click', function (event) {
      var purchaseButton = event.target.closest && event.target.closest('[data-ovale-atc]');
      if (purchaseButton && root.contains(purchaseButton)) requireSize(event);
    }, true);

    function celebrateAddToCart() {
      if (window.matchMedia && window.matchMedia('(min-width: 750px)').matches) return;
      var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var priorBurst = addButton.querySelector('.ovale-atc__burst');
      var burst;
      var sparks = [
        [-128, -46, -24, 10, 0, '#c99258'],
        [-102, -72, -12, 12, 55, '#2f8b83'],
        [-70, -55, 20, 9, 110, '#c99258'],
        [-36, -78, -18, 10, 35, '#d2e8e4'],
        [0, -70, 18, 12, 85, '#c99258'],
        [38, -80, -16, 9, 10, '#2f8b83'],
        [74, -58, 24, 11, 100, '#c99258'],
        [108, -74, 14, 10, 45, '#2f8b83'],
        [132, -42, -20, 12, 75, '#c99258'],
        [-94, -28, 14, 9, 125, '#2f8b83'],
        [96, -30, -12, 9, 135, '#d2e8e4']
      ];

      if (priorBurst) priorBurst.remove();
      addButton.classList.remove('is-celebrating');
      void addButton.offsetWidth;
      addButton.classList.add('is-celebrating');

      if (!reducedMotion) {
        burst = document.createElement('span');
        burst.className = 'ovale-atc__burst';
        burst.setAttribute('aria-hidden', 'true');
        sparks.forEach(function (spark) {
          var star = document.createElement('i');
          star.className = 'fa fa-star ovale-atc__spark';
          star.style.setProperty('--ovale-spark-x', spark[0] + 'px');
          star.style.setProperty('--ovale-spark-y', spark[1] + 'px');
          star.style.setProperty('--ovale-spark-rotate', spark[2] + 'deg');
          star.style.setProperty('--ovale-spark-size', spark[3] + 'px');
          star.style.setProperty('--ovale-spark-delay', spark[4] + 'ms');
          star.style.setProperty('--ovale-spark-color', spark[5]);
          burst.appendChild(star);
        });
        addButton.appendChild(burst);
      }

      window.setTimeout(function () {
        addButton.classList.remove('is-celebrating');
        if (burst && burst.parentNode) burst.remove();
      }, 1050);
    }

    addButton.addEventListener('amour:cart:add:success', celebrateAddToCart);

    var linkedProduct = form.querySelector('[data-ovale-linked-product]');
    if (linkedProduct) {
      linkedProduct.addEventListener('click', function (event) {
        event.preventDefault();
        var href = linkedProduct.href;
        var size = sizeSelect ? sizeSelect.value : '';
        var linkedDataUrl = new URL(href);
        linkedDataUrl.pathname = linkedDataUrl.pathname.replace(/\/$/, '') + '.js';
        linkedDataUrl.search = '';
        fetch(linkedDataUrl.href, { credentials: 'same-origin' })
          .then(function (response) { return response.ok ? response.json() : Promise.reject(); })
          .then(function (linked) {
            var selectedByName = {};
            var selectedByRole = {};
            groups.forEach(function (group) {
              var groupName = (group.getAttribute('data-option-name') || '').trim().toLowerCase().replace(/:$/, '');
              var groupRole = group.getAttribute('data-option-role') || inferOptionRole(groupName, []);
              var groupIndex = Number(group.getAttribute('data-option-index'));
              selectedByName[groupName] = selected[groupIndex] || '';
              selectedByRole[groupRole] = selected[groupIndex] || '';
            });
            function matchesLinked(variant, ignoreSize) {
              return variant.options.every(function (value, index) {
                var linkedOption = (linked.options || [])[index];
                var linkedName = String((linkedOption && linkedOption.name) || linkedOption || '').trim().toLowerCase().replace(/:$/, '');
                var linkedValues = (linked.variants || []).map(function (linkedVariant) { return linkedVariant.options[index]; });
                var linkedRole = inferOptionRole(linkedName, linkedValues);
                var sourceValue = selectedByRole[linkedRole] || selectedByName[linkedName] || '';
                if (lemeraudePair && ignoreSize && linkedRole === 'size') return true;
                if (lemeraudePair && linkedRole === 'carat') return parseFloat(value) === parseFloat(sourceValue);
                if (ailesPair && linkedRole === 'size' && /^(custom|other) size/i.test(sourceValue) && /^(custom|other) size/i.test(value)) return true;
                if (!sourceValue) return isPlaceholderValue(value);
                return value === sourceValue;
              });
            }
            var target = (linked.variants || []).find(function (variant) { return matchesLinked(variant, false); });
            var chooseSize = lemeraudePair && !target;
            if (chooseSize) target = (linked.variants || []).find(function (variant) { return matchesLinked(variant, true); });
            var destination = new URL(href);
            var previewThemeId = new URL(window.location.href).searchParams.get('preview_theme_id');
            if (previewThemeId) destination.searchParams.set('preview_theme_id', previewThemeId);
            if (size && target && !isPlaceholderVariant(target)) destination.searchParams.set('variant', target.id);
            if (ailesPair && target) {
              destination.searchParams.set('variant', target.id);
              if (!size || isPlaceholderVariant(target)) chooseSize = true;
            }
            if (chooseSize && target) destination.searchParams.set('choose_size', '1');
            window.location.assign(destination.href);
          })
          .catch(function () { window.location.assign(href); });
      });
    }

    var gallery = root.querySelector('[data-ovale-gallery]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-ovale-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-ovale-gallery-dot]'));
    var currentLabel = root.querySelector('[data-ovale-gallery-current]');
    var lightbox = root.querySelector('[data-ovale-lightbox]');
    var lightboxDialog = lightbox && lightbox.querySelector('.ovale-lightbox__dialog');
    var lightboxImage = lightbox && lightbox.querySelector('[data-ovale-lightbox-image]');
    var lightboxStatus = lightbox && lightbox.querySelector('[data-ovale-lightbox-status]');
    var lightboxTriggers = Array.prototype.slice.call(root.querySelectorAll('[data-ovale-lightbox-trigger]'));
    var lightboxCloseButtons = lightbox ? Array.prototype.slice.call(lightbox.querySelectorAll('[data-ovale-lightbox-close]')) : [];
    var lightboxPrevious = lightbox && lightbox.querySelector('[data-ovale-lightbox-previous]');
    var lightboxNext = lightbox && lightbox.querySelector('[data-ovale-lightbox-next]');
    var lightboxMedia = window.matchMedia && window.matchMedia('(min-width: 1024px)');
    var lightboxIndex = 0;
    var lightboxReturnFocus = null;
    var lightboxBodyOverflow = '';
    var scrollFrame;

    function setCurrentSlide(index) {
      slides.forEach(function (slide, slideIndex) {
        slide.classList.toggle('is-active', slideIndex === index);
        slide.classList.toggle('slick-current', slideIndex === index);
      });
      dots.forEach(function (dot, dotIndex) {
        dot.classList.toggle('is-active', dotIndex === index);
        dot.setAttribute('aria-current', dotIndex === index ? 'true' : 'false');
      });
      currentLabel.textContent = String(index + 1);
    }

    if (gallery && slides.length) {
      gallery.addEventListener('scroll', function () {
        window.cancelAnimationFrame(scrollFrame);
        scrollFrame = window.requestAnimationFrame(function () {
          var galleryLeft = gallery.getBoundingClientRect().left;
          var closest = 0;
          var distance = Infinity;
          slides.forEach(function (slide, index) {
            var value = Math.abs(slide.getBoundingClientRect().left - galleryLeft);
            if (value < distance) { distance = value; closest = index; }
          });
          setCurrentSlide(closest);
        });
      }, { passive: true });
      dots.forEach(function (dot, index) {
        dot.addEventListener('click', function () {
          slides[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        });
      });
    }

    function updateLightbox(index) {
      var trigger;
      if (!lightboxTriggers.length) return;
      lightboxIndex = (index + lightboxTriggers.length) % lightboxTriggers.length;
      trigger = lightboxTriggers[lightboxIndex];
      lightboxImage.src = trigger.getAttribute('data-ovale-lightbox-src');
      lightboxImage.alt = trigger.getAttribute('data-ovale-lightbox-alt') || product.title;
      lightboxStatus.textContent = 'Image ' + (lightboxIndex + 1) + ' of ' + lightboxTriggers.length;
    }

    function closeLightbox() {
      var returnFocus;
      if (!lightbox || lightbox.hidden) return;
      returnFocus = lightboxReturnFocus;
      lightbox.hidden = true;
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = lightboxBodyOverflow;
      if (returnFocus && document.documentElement.contains(returnFocus)) {
        window.requestAnimationFrame(function () { returnFocus.focus({ preventScroll: true }); });
      }
    }

    function openLightbox(index, trigger) {
      if (!lightbox || !lightboxMedia || !lightboxMedia.matches) return;
      lightboxReturnFocus = trigger;
      lightboxBodyOverflow = document.body.style.overflow;
      updateLightbox(index);
      lightbox.hidden = false;
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      window.requestAnimationFrame(function () {
        var closeButton = lightbox.querySelector('.ovale-lightbox__close');
        if (closeButton) closeButton.focus({ preventScroll: true });
      });
    }

    if (lightbox && lightboxTriggers.length) {
      lightboxTriggers.forEach(function (trigger, index) {
        trigger.addEventListener('click', function () { openLightbox(index, trigger); });
      });
      lightboxCloseButtons.forEach(function (button) {
        button.addEventListener('click', closeLightbox);
      });
      if (lightboxPrevious) lightboxPrevious.addEventListener('click', function () { updateLightbox(lightboxIndex - 1); });
      if (lightboxNext) lightboxNext.addEventListener('click', function () { updateLightbox(lightboxIndex + 1); });
      lightbox.addEventListener('keydown', function (event) {
        var focusable;
        var firstFocusable;
        var lastFocusable;
        if (event.key === 'Escape') {
          event.preventDefault();
          closeLightbox();
          return;
        }
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          updateLightbox(lightboxIndex - 1);
          return;
        }
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          updateLightbox(lightboxIndex + 1);
          return;
        }
        if (event.key !== 'Tab' || !lightboxDialog) return;
        focusable = Array.prototype.slice.call(lightboxDialog.querySelectorAll('button:not([disabled])'));
        firstFocusable = focusable[0];
        lastFocusable = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === firstFocusable) {
          event.preventDefault();
          lastFocusable.focus();
        } else if (!event.shiftKey && document.activeElement === lastFocusable) {
          event.preventDefault();
          firstFocusable.focus();
        }
      });
      if (lightboxMedia && lightboxMedia.addEventListener) {
        lightboxMedia.addEventListener('change', function (event) {
          if (!event.matches) closeLightbox();
        });
      }
    }

    if (explicitVariant) {
      hiddenId.value = explicitVariant.id;
      updateState({ keepUrl: true });
    } else {
      updateState();
    }
  }

  function boot() {
    var roots = document.querySelectorAll('[data-ovale-pdp]');
    if (!roots.length) return;
    document.documentElement.classList.add('ovale-pilot-page');
    roots.forEach(function (root) {
      initOvaleDelivery(root);
      initOvalePdp(root);
      initOvalePurchaseSticky(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
